import PortalTextLink from '@nexidigital/portaltextlink';
import DOMPurify from 'dompurify';
import React from 'react';
import { nullSafe, openUrl } from './globalMethods';

const renderNode = (node, key) => {
  // Testo semplice
  if (node.nodeType === Node.TEXT_NODE) {
    if (!node.textContent.trim()) {
      return null;
    }
    return node.textContent;
  }

  // Solo nodi elemento
  if (node.nodeType !== Node.ELEMENT_NODE) {
    return null;
  }

  const children = Array.from(node.childNodes).map((child, i) =>
    renderNode(child, `${key}-${i}`)
  );

  switch (node.tagName.toLowerCase()) {
    case 'a':
      return (
        <PortalTextLink
          key={key}
          underline="always"
          label={children}
          onClick={() => openUrl(node.getAttribute('href'), true)}
          textLinkBase
        />
      );

    case 'strong':
    case 'b':
      return (
        <strong key={key}>
          {children}
        </strong>
      );

    case 'em':
    case 'i':
      return (
        <em key={key}>
          {children}
        </em>
      );

    case 'br':
      return <br key={key} />;

    case 'p':
      return (
        <p key={key}>
          {children}
        </p>
      );

    case 'ul':
      return (
        <ul key={key}>
          {children}
        </ul>
      );

    case 'li': return (
      <li key={key}>
        {children}
      </li>
    );

    default:
      // Fallback: renderizza solo i figli
      return <React.Fragment key={key}>{children}</React.Fragment>;
  }
};

const PurifyAndReplaceHTML = (apiText) => {
  const textSafe = nullSafe(() => apiText, '')
  const normalizedText = textSafe
    .replace(/\\n/g, '<br/>')
    .replace(/\\"/g, '"');
  const sanitizedHTML = DOMPurify.sanitize(normalizedText, {
    ALLOWED_TAGS: ['a', 'b', 'strong', 'em', 'i', 'br', 'p', 'ul', 'li'],
    ALLOWED_ATTR: ['href', 'target'],
  });

  const parser = new DOMParser();
  const doc = parser.parseFromString(sanitizedHTML, 'text/html');

  return (
    <span>
      {Array.from(doc.body.childNodes).map((node, i) =>
        renderNode(node, `root-${i}`)
      )}
    </span>
  );
};

export default PurifyAndReplaceHTML;
